module.exports = __webpack_public_path__ + "media/media/product-card/item-2-bc266fe9ee9195006acb4570b3853a94.png";